const collator = new Intl.Collator(undefined, {
  sensitivity: 'base',
  numeric: true,
  usage: 'sort',
});

export function compareByTitle<T extends { id: string }>(
  getTitle: (x: T) => string | undefined,
): (a: T, b: T) => number {
  return (a, b) => {
    const ta = (getTitle(a) ?? '').trim();
    const tb = (getTitle(b) ?? '').trim();
    if (!ta && tb) return 1;
    if (ta && !tb) return -1;
    const primary = collator.compare(ta, tb);
    if (primary !== 0) return primary;
    return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
  };
}
